import { BOOLEAN } from '@/plugins/sdk/fields'

export default {
  label: 'Yes',
  operator: 'is',
  fields: [ BOOLEAN ],
  isValidValue (value) {
    return value === 1
  }
}
